// Legacy WordPress URL: /blog → /learn (Learning Hub) (301).
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/blog")({
  beforeLoad: () => {
    throw redirect({ to: "/learn", statusCode: 301 });
  },
});
